/* eslint-disable react-native/no-inline-styles */
import React, { useState } from "react"
import { View, Text, TouchableOpacity, Image, ScrollView } from "react-native"
import { CustomHeader, Screen } from "components"
import { style } from "./styles"
import { useNavigation } from "@react-navigation/native"
import { translate } from "i18n"
import LinearGradient from "react-native-linear-gradient"
import goldCrown from "../../../../assets/images/crown-gold.png"
import silverCrown from "../../../../assets/images/crown-silver.png"
import bronzeCrown from "../../../../assets/images/crown-bronze.png"
import { colors } from "colors"
import { useColor } from "app/theme/getThemes"

export const MemberUpgrade = () => {
  const navigation = useNavigation()
  const [benefitIndex, setCurrentTierIndex] = useState(0)
  const { companyTheme } = useColor()

  const tiers = [
    {
      name: "Gold Tier",
      colorGradient: ["#FFF5B7", "#FFD700", "#FFB14E", "#D99200"],
      point: 550,
      nextPoint: 800,
      benefits: [{ name: "RM50 welcome voucher" }, { name: "180 pts = RM10 voucher" }],
      crownImage: goldCrown,
      price: 388,
    },
    {
      name: "Silver Tier",
      colorGradient: ["#E0E0E0", "#C0C0C0", "#A9A9A9", "#D4D4D4"],
      point: 200,
      nextPoint: 400,
      benefits: [{ name: "RM30 welcome voucher" }, { name: "200 pts = RM10 voucher" }],
      crownImage: silverCrown,
      price: 188,
    },
    {
      name: "Bronze Tier",
      colorGradient: ["#E3B778", "#CD7F32", "#D8A162", "#A76B29"],
      point: 100,
      nextPoint: 200,
      benefits: [{ name: "RM10 welcome voucher (immediate use)" }],
      crownImage: bronzeCrown,
      price: 88,
    },
  ]

  return (
    <>
      <CustomHeader headerTitle={"Membership Upgrade Plan"} />
      <Screen>
        <ScrollView
          style={style.detailsContainer}
          contentContainerStyle={{ paddingBottom: 50 }}
          showsVerticalScrollIndicator={false}
        >
          <Text style={[style.tierTitle, { color: companyTheme.first }]}>
            Tired of slow membership progress?{" "}
          </Text>
          <Text style={style.benefitText}>
            Grab our exclusive package to quickly reach your desired tier!
          </Text>

          {tiers.map((benefit, index) => (
            <TouchableOpacity key={index}>
              <View style={{ flexDirection: "row", alignItems: "center", marginTop: 20 }}>
                <Image source={benefit.crownImage} style={style.pointImage} />
                <Text style={style.benefitText}>{benefit.name}</Text>
              </View>
              <LinearGradient
                style={[
                  style.tierContentContainer,
                  {
                    padding: 0,
                    shadowColor: "#000",
                    shadowOffset: { width: 0, height: 4 },
                    shadowOpacity: 0.3,
                    shadowRadius: 6,
                  },
                ]}
                colors={benefit.colorGradient}
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 0 }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    padding: "5%",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    zIndex: 999,
                  }}
                >
                  <Text style={[style.tierSpendText, { color: "black", fontSize: 25 }]}>
                    {benefit.name.toUpperCase()}
                  </Text>
                  <Image
                    source={benefit.crownImage}
                    resizeMode="contain"
                    style={[style.voucherImage, { width: 70, height: 70 }]}
                  />
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    padding: "5%",
                    justifyContent: "space-between",
                    alignItems: "flex-end",
                    zIndex: 999,
                  }}
                >
                  <Text style={[style.tierTitle, { fontSize: 20 }]}>RM {benefit.price}</Text>
                </View>

                <View
                  style={{
                    position: "absolute",
                    width: 200,
                    height: 200,
                    borderRadius: 100,
                    backgroundColor: benefit.colorGradient[0],
                    opacity: 0.2,
                    bottom: -80,
                    left: -50,
                    zIndex: 1,
                  }}
                />
                <View
                  style={{
                    position: "absolute",
                    width: 200,
                    height: 200,
                    borderRadius: 100,
                    backgroundColor: benefit.colorGradient[3],
                    opacity: 0.2,
                    top: -80,
                    right: -50,
                    zIndex: 1,
                  }}
                />
              </LinearGradient>
              <View style={{ marginTop: 10, display: "flex", alignItems: "center" }}>
                <Text
                  style={[
                    style.benefitText,
                    { color: colors.darkerGrey, textDecorationLine: "underline" },
                  ]}
                >
                  Click to view more details
                </Text>
              </View>
            </TouchableOpacity>
          ))}
        </ScrollView>
      </Screen>
    </>
  )
}
